<template>
    <window-portal :open="dataProps.show" @close="dataProps.show = false">
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center><div><p style="font-size: 30px;">Vista previa de impresión balance de comprobación</p></div></center>
            <br/>
            <center>
                <button class="btnclean" style="font-size: 18px;" @click="Print()">
                    Imprimir
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="Download()">
                    Descargar
                </button>
                
            </center>
            <center><div v-if="loading"><p>Cargando...</p></div></center>

        </div>
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center v-if="mailLabel">
                {{ mailLabel }}
            </center>
        </div>

        <div class="book" style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">
                <div style="margin: 0 auto; width: 1000px;">
                    <div ref="dataprint" style="margin: 0 !important; padding: 0 !important;">
                        <!--div style="position: relative; width: 1000px; min-height: 1294px; background: white;"-->
                        <div v-for="( { activos, pasivos } , indexPage) in pages" :key="indexPage" style="position: relative; width: 1000px; min-height: 1294.1px; background: white;">
                            <hr/>
                            <div class="subpage" style="height: 1250px; padding-top: 20px; overflow: hidden;">
                                <div style="margin-left: 80px; margin-right: 50px;">
                                    <div style="text-align: center; font-size: 12px;">
                                        <h2>{{ businessName }}</h2>
                                        <p>Balance de Comprobación a la fecha {{ dataProps.lastDayOfDate }} {{ dataProps.balanceDate }}.</p>
                                        <p>{{ getcurrency }}</p>
                                    </div>
                                    <!-- <div>
							
                                        <p>Balance General a la Fecha de {{ dataProps.balanceDate }} {{ dataProps.balanceType }}</p>
                                    </div> -->
                                    <br/>
                                    <!-- Heres is teh body -->
                                    <div style="width: 100%;">
                                        <table v-if="activos.values.length > 0" style="width: 100% !important; margin-bottom: 22px; font-size: 12px; border-collapse: collapse;">
                                            <thead style="width: 100%;">
                                                <tr>
                                                    <th style="text-align: center;" colspan="6">
                                                        ACTIVOS
                                                    </th>
                                                </tr>
                                                <tr style="border-top: 2px solid; border-bottom: 1px solid;">
                                                    <th style="text-align: left;">Cuenta</th>
                                                    <th style="text-align: left;">Concepto</th>
                                                    <th style="text-align: right;">Saldo Anterior</th>
                                                    <th style="text-align: right;">Cargos</th>
                                                    <th style="text-align: right;">Abonos</th>
                                                    <th style="text-align: right;">Saldo Actual</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, indexActivo) in activos.values" :key="indexActivo">
                                                    <td style="padding: 2px; width: 10%;">{{ item["account_code"] }}</td>
                                                    <td style="padding: 2px; width: 50%;">{{ item["account_description"] }}</td>
                                                    <td style="padding: 2px; width: 10%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["PreviousBalanceFormatted"].replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 10%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["chargesFormatted"].replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 10%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["paymentsFormatted"].replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 10%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["CurrentBalanceFormatted"].replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr style="border-top: 1px solid;" v-if="activos?.isLastPage">
                                                    <th colspan="5" style="text-align: right;">TOTAL ACTIVO Y EGRESOS</th>
                                                    <td style="padding: 2px; width: 15%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ getTotal( 'activos' ).replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                        <table v-if="pasivos.values.length > 0" style="width: 100% !important; font-size: 12px; border-collapse: collapse;">
                                            <thead style="text-align: center; width: 100%;">
                                                <tr>
                                                    <th colspan="5">
                                                        PASIVOS
                                                    </th>
                                                </tr>
                                                <tr style="border-top: 2px solid; border-bottom: 1px solid;">
                                                    <th style="text-align: left;">Cuenta</th>
                                                    <th style="text-align: left;">Concepto</th>
                                                    <th style="text-align: right;">Saldo Anterior</th>
                                                    <th style="text-align: right;">Cargos</th>
                                                    <th style="text-align: right;">Abonos</th>
                                                    <th style="text-align: right;">Saldo Actual</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, indexActivo) in pasivos.values" :key="indexActivo">
                                                    <td style="padding: 2px; width: 10%;">{{ item["account_code"] }}</td>
                                                    <td style="padding: 2px; width: 50%;">{{ item["account_description"] }}</td>
                                                    <td style="padding: 2px; width: 10%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["PreviousBalanceFormatted"].replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 10%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["chargesFormatted"].replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 10%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["paymentsFormatted"].replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                    <td style="padding: 2px; width: 10%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ item["CurrentBalanceFormatted"].replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr style="border-top: 1px solid;" v-if="pasivos?.isLastPage">
                                                    <th colspan="5" style="text-align: right;">TOTAL PASIVO E INGRESOS</th>
                                                    <td style="padding: 2px; width: 15%; text-align: right;">
                                                        <div style="display: flex; justify-content: space-between; width: 100%;">
                                                            <span>{{`${ currencySymbol } `}}</span>
                                                            <span style="word-wrap: anywhere;">{{ getTotal( 'pasivos' ).replaceAll('$', '') }}</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>

                                    </div>
                                </div>
                                
                                <div style="position: absolute; bottom: 0; width: 100%; left: 80px">
                                    <p style="font-size:10px;">Pagina {{ indexPage+1 }} de {{ pages.length }}</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
        </div>
    </window-portal>
</template>

<script>

import jsPDF from "jspdf"
//import QRCode from 'qrcode';
//import html2canvas from "html2canvas"
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue"
import { addFormatToNIT, addFormatNRC } from "../../helpers/misc"
import { numberWithCommas } from "../../helpers/money";
import {numberToText} from '@/helpers/conveterNumberText.js'

export default {
    name: "PrintCheckBalance",
    props: ['dataProps' ],
    components: {WindowPortal},
    data() {
        return {
            header: null,
            footer: null,
            loading: false,
            //seal: "",
            //sealBranch: "",
            pages: [],
            //valuesRows: []
            mailLabel: null,
            valuesRows: [],
            urlQr: null,
            typePrint: 0,
            consolidateValues: {},
            borderTp: 0,
            rowsNumberPerReport: 55,
            businessName: JSON.parse( localStorage.getItem( 'user' ) ).business,
            currencySymbol: JSON.parse( localStorage.getItem( 'branch' ) ).Currency,
        }
    },
    mounted() {
        this.calculatePagesOfDoc()
        this.getHeaderFooter()
    },
    computed: {
        getcurrency() {
            const countries = this.$store.getters.getCountries;
            const currency = countries.find( current => current.currency_symbol === this.currencySymbol );

            return currency.currency_name.toUpperCase();
        },
        BillingNrc() {
            return addFormatNRC(this.dataProps.data.branch.BusinessBillingNRC)
        },
        BillingNit() {
            //console.log(this.dataProps.data.branch.BusinessBillingNIT);
            return addFormatToNIT(this.dataProps.data.branch.BusinessBillingNIT)
        }
    },
    watch: {
        'dataProps.show'() {
            if(this.dataProps.show){
                setTimeout(async () => {
                    await this.calculatePagesOfDoc()
                }, 0);
            }
        },
        'dataProps'() {
            this.calculatePagesOfDoc()
        }
    },
    methods: {
        getTotal( recordType ) {
            let accum = 0.00;
            for( const page of this.pages ) {
                const { values } = page[ recordType ];
                for( const record of values ) {
                    if( record.Type === 1 ) {
                        accum += record.CurrentBalance ? record.CurrentBalance : 0;
                    }
                }
            }
            return `${ this.currencySymbol }${ numberWithCommas( accum ) }`;
        },
        GetnumberToText(number) {
            if(number) return numberToText(number)
            else return ''
        },
        numberWithCommas(x) {
            return numberWithCommas(x);
        },
        getHeaderFooter() {
            let search = {};
            search.ID_business = JSON.parse(localStorage.getItem("user")).businessid || ""
            search.ID_branch = JSON.parse(localStorage.getItem("user")).branch || ""
            this.$API.HF.getHF(search).then((data) => {
                let header = [], footer = [];
                header = data.filter((x) => x.State == '1' && x.Type == 'Header');
                this.header = header.length > 0 ? JSON.parse(header[0].Body).html : '';
                this.header = this.header.replace(/(\n)/gm, "");
                footer = data.filter((x) => x.State == '1' && x.Type == 'Footer');
                this.footer = footer.length > 0 ? JSON.parse(footer[0].Body).html : '';
            })
        },
        calculatePagesOfDoc() {
            try{
                const { data: { activos, pasivos } } = this.dataProps;
                this.pages = [];
                this.typePrint = 0;
                let currentPage = 0;
                let currentRowsPerPage = 0;

                this.pages[ currentPage ] = { activos: { values: [] }, pasivos: { values: [] } };

                for( const i in activos ) {
                    const element = activos[ i ];

                    if( currentRowsPerPage < this.rowsNumberPerReport ) {
                        currentRowsPerPage ++;
                        if( i == activos.length - 1 ) {
                            this.pages[ currentPage ].activos.values.push( element );
                            this.pages[ currentPage ].activos.isLastPage = true;
                        } else {
                            this.pages[ currentPage ].activos.values.push( element );
                        }
                    } else {
                        currentPage ++;
                        currentRowsPerPage = 0;
                        this.pages[ currentPage ] = { activos: { values: [ element] }, pasivos: { values: [] } };
                    }
                }

                for( const i in pasivos ) {
                    const element = pasivos[ i ];

                    if( currentRowsPerPage < this.rowsNumberPerReport ) {
                        currentRowsPerPage ++;
                        if( i == pasivos.length - 1 ) {
                            this.pages[ currentPage ].pasivos.values.push( element );
                            this.pages[ currentPage ].pasivos.isLastPage = true;
                        } else {
                            this.pages[ currentPage ].pasivos.values.push( element );
                        }
                    } else {
                        currentPage ++;
                        currentRowsPerPage = 0;
                        this.pages[ currentPage ] = { activos: { values: [] }, pasivos: { values: [ element ] } }
                    }
                }
            }
            catch(err) {
                alert(err)
            }
        },

        async Print(){
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            })
            
            
            //doc.deletePage(2)

            doc.autoPrint({variant: 'non-conform'});
            const blob = doc.output("bloburl")
            window.open(blob)

            this.loading = false
        },

        async Download(){
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            });
            
            //doc.deletePage(2)
            doc.save(`Balance de Comprobación - ${ this.businessName } - ${ this.dataProps.balanceDate }.pdf`); //Agregado por Juan 13082023

            this.loading = false
        },
        async sendMail() {
            try {
                this.mailLabel = null;
                var doc = new jsPDF('p', 'pt', 'letter')
                //console.log(doc);
                //console.log(this.$refs.dataprint);
                await doc.html(this.$refs.dataprint, {
                    callback: function(doc){
                        doc.output()
                    },
                    x: 0,
                    y: 0,
                    margin: [0, 0, 0, 0],
                    html2canvas:{ 
                        scale: 0.612,
                        //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                        useCORS: true,
                        logging: false,
                        allowTaint: true
                    },
                });
                
                const body = {
                    dtefilebuffer: new Buffer.from(doc.output('arraybuffer')),
                    dtejson: this.dataProps.data.dteJson,
                    dtefilebufferfilename: this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".pdf"
                };

                // console.log(body);
                this.$API.invoices.sendInvoiceMail(body);

                this.mailLabel = 'Se envió el correo correctamente';
                this.$emit('mailSent');
            } catch (error) {
                this.mailLabel = 'Ocurrió un error al enviar el correo';
                console.log(error);
            }
        },
        async downLoadJSON() {
            try {
                const aElement = document.createElement('a');
                aElement.setAttribute('download', this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".pdf");
                const blob = new Blob([JSON.stringify(this.dataProps.data.dteJson)], { type: 'application/json' });
                const href = URL.createObjectURL(blob);
                aElement.href = href;
                aElement.download = this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".json";
                aElement.click();
                URL.revokeObjectURL(href);
            } catch (error) {
                this.mailLabel = 'Ocurrió un error al enviar el correo';
                console.log(error);
            }
        }
    }
}
</script>

<style scoped>

    .u-row .u-col-100{
        width: 100% !important;
    }
    .btnclean{
        border-radius: 15px;
        border: 1px solid white;
        background-color: #F29D35 !important;
        color: white !important;
    }

    * {
        font-family: Arial, Helvetica, sans-serif !important;
    }

</style>
